module.exports = __webpack_public_path__ + "img/horizontal_6_2_8003.3ecf97e3.png";